module.exports = __webpack_public_path__ + "static/media/artificial-intelligence.c565f1b4.svg";